import React from 'react';
import { useSearchParams } from 'react-router-dom';
import CardContainerForDevelopment from '../../Components/CardContainerForDevelopment/CardContainerForDevelopment';
import FilterView from '../../Components/FilterView/FilterView';
import {
  getFiltersFromSearchParams,
  filtersToSearchParams,
} from '../../utils/propertyCatalogFilters';
import style from './Desarrollo.module.css'

const Desarrollos = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const filtersFromURL = getFiltersFromSearchParams(searchParams);
  const page = parseInt(searchParams.get('page'), 10) || 1;

  const handleFilterChange = (filters) => {
    setSearchParams(filtersToSearchParams(filters, { page: 1 }));
  };

  return (
    <div className={style.container}>
      <FilterView onFilterChange={handleFilterChange} initialFilters={filtersFromURL} />
      <CardContainerForDevelopment filters={{ ...filtersFromURL, page }} />
    </div>
  );
};

export default Desarrollos;
